
import React from "react";
import { LucideProps } from "lucide-react";

export const TikTokIcon = ({ 
  size = 24, 
  className = "", 
  ...props 
}: LucideProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="none"
      strokeWidth="0"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path d="M19.321 5.562a5.122 5.122 0 0 1-2.867-2.821c-.22-.56-.275-.762-.355-1.326V1h-3.858v15.425c0 1.985-1.615 3.599-3.6 3.599a3.6 3.6 0 0 1-3.6-3.599 3.6 3.6 0 0 1 5.018-3.313V9.334a7.257 7.257 0 0 0-1.418-.14A7.276 7.276 0 0 0 1.365 16.47a7.276 7.276 0 0 0 7.276 7.276c4.02 0 7.276-3.257 7.276-7.276V9.681a8.93 8.93 0 0 0 5.503 1.824V7.722a5.148 5.148 0 0 1-2.098-2.16Z" />
    </svg>
  );
};

export default TikTokIcon;
